import React from "react";
import { ArrowRight, CheckCircle2, Star } from "lucide-react";
import { HERO } from "../mock";

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

const Hero = () => {
  return (
    <section id="home" className="relative overflow-hidden pt-32 pb-20 lg:pt-40 lg:pb-28">
      {/* decorative blobs */}
      <div className="pointer-events-none absolute -top-24 -right-24 h-96 w-96 rounded-full bg-[var(--brand)]/10 blur-3xl" />
      <div className="pointer-events-none absolute top-40 -left-24 h-80 w-80 rounded-full bg-[var(--accent)]/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        <div className="animate-[fadeUp_0.7s_ease-out]">
          <span className="inline-flex items-center gap-2 rounded-full bg-[var(--brand)]/10 px-4 py-1.5 text-sm font-semibold text-[var(--brand)]">
            <Star size={15} className="fill-[var(--brand)]" />
            {HERO.eyebrow}
          </span>

          <h1 className="mt-6 font-heading text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight text-[var(--ink)]">
            {HERO.titleLead}{" "}
            <span className="relative inline-block text-[var(--brand)]">
              {HERO.titleHighlight}
              <svg className="absolute -bottom-2 left-0 w-full" height="12" viewBox="0 0 300 12" fill="none" preserveAspectRatio="none">
                <path d="M2 9C60 3 240 3 298 9" stroke="var(--accent)" strokeWidth="5" strokeLinecap="round" />
              </svg>
            </span>
          </h1>

          <p className="mt-6 max-w-xl text-lg leading-relaxed text-[var(--muted-ink)]">
            {HERO.description}
          </p>

          <div className="mt-8 flex flex-wrap gap-4">
            <button
              onClick={() => scrollTo("#contact")}
              className="group inline-flex items-center gap-2 rounded-full bg-[var(--brand)] px-7 py-3.5 font-bold text-white shadow-lg shadow-[var(--brand)]/30 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl"
            >
              {HERO.primaryCta}
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </button>
            <button
              onClick={() => scrollTo("#services")}
              className="inline-flex items-center rounded-full border-2 border-[var(--ink)]/10 bg-white px-7 py-3.5 font-bold text-[var(--ink)] transition-all duration-300 hover:border-[var(--brand)] hover:text-[var(--brand)]"
            >
              {HERO.secondaryCta}
            </button>
          </div>

          <div className="mt-9 flex flex-wrap gap-x-5 gap-y-2">
            {HERO.pills.slice(0, 4).map((p) => (
              <span key={p} className="inline-flex items-center gap-1.5 text-sm font-medium text-[var(--muted-ink)]">
                <CheckCircle2 size={16} className="text-[var(--brand)]" />
                {p}
              </span>
            ))}
          </div>
        </div>

        <div className="relative animate-[fadeUp_0.9s_ease-out]">
          <div className="relative overflow-hidden rounded-[28px] shadow-2xl shadow-[var(--brand)]/20">
            <img
              src={HERO.image}
              alt="Global sourcing and shipping"
              className="h-[440px] w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[var(--brand)]/40 to-transparent" />
          </div>

          {/* floating card */}
          <div className="absolute -bottom-6 -left-6 hidden sm:flex items-center gap-3 rounded-2xl bg-white p-4 shadow-xl border border-gray-100">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--accent)] text-[var(--ink)]">
              <CheckCircle2 size={22} />
            </span>
            <div>
              <p className="font-heading text-lg font-extrabold text-[var(--ink)] leading-none">Quality Assured</p>
              <p className="text-xs text-[var(--muted-ink)] mt-1">Free inspections on every order</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
